(() => {
  function initialize(root) {
    if (root.dataset.daylightReady) return;
    root.dataset.daylightReady = 'true';
    const cartLabel = root.querySelector('[data-add-to-cart-text]');
    if (cartLabel) {
      const formatCartLabel = () => {
        if (/^Add to cart(?:\s*[–—-]\s*Save.*)?$/i.test(cartLabel.textContent.trim()) && cartLabel.textContent.trim() !== 'Add to Cart') cartLabel.textContent = 'Add to Cart';
      };
      new MutationObserver(formatCartLabel).observe(cartLabel, {childList:true, characterData:true, subtree:true});
      formatCartLabel();
    }
    const container = root.querySelector('[data-gob-included]');
    if (!container) return;
    const dialog = container.querySelector('dialog');
    const opener = container.querySelector('[data-gob-included-open]');
    const closer = container.querySelector('[data-gob-included-close]');
    const variants = JSON.parse(container.querySelector('[data-gob-included-variants]').textContent);
    const panes = [...container.querySelectorAll('[data-gob-included-tab]')];
    const version = container.querySelector('[data-gob-included-version]');
    const unknown = container.querySelector('[data-gob-included-unknown]');
    function update(id) {
      const item = variants.find(v => String(v.id) === String(id));
      const tab = item ? item.tab : 0;
      panes.forEach(pane => { pane.hidden = Number(pane.dataset.gobIncludedTab) !== tab; });
      unknown.hidden = Boolean(tab);
      version.textContent = item ? item.title : '';
      container.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gobIncludedVersionId) === String(id) ? 'true' : 'false'));
    }
    const select = root.querySelector('[data-product-select]');
    const initialVariant = root.querySelector('[data-current-variant-json]');
    let currentId = initialVariant ? JSON.parse(initialVariant.textContent).id : select && select.value;
    update(currentId);
    container.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.addEventListener('click', () => update(button.dataset.gobIncludedVersionId)));
    opener.addEventListener('click', () => {
      update(currentId);
      if (!dialog.open) dialog.showModal();
      container.querySelector('.gob-included-scroll').scrollTop = 0;
      opener.setAttribute('aria-expanded', 'true');
    });
    closer.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({preventScroll:true});
    });
    document.addEventListener('variant:change', event => {
      const variant = event.detail && event.detail.variant;
      if (variant && variants.some(v => String(v.id) === String(variant.id))) {
        currentId = variant.id;
        update(currentId);
      }
    });
  }
  const start = () => document.querySelectorAll('[data-gob-daylight]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
